import { render, staticRenderFns } from "./CellRendererChips.vue?vue&type=template&id=2468c128&"
import script from "./CellRendererChips.vue?vue&type=script&lang=ts&"
export * from "./CellRendererChips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports